<template>
    <input-row label="회원유형">{{ userType }}</input-row>
</template>

<script>
import { INDIVIDUAL_KINDS, USER_TYPES } from "@/assets/variables";

import InputRow from "@/components/client/dumb/input-row.vue";

export default {
    components: {
        InputRow,
    },
    props: ["value"],
    computed: {
        userType() {
            if (this.value.type == USER_TYPES.ORGANIZATION) return "기업회원";
            else if (this.value.type == USER_TYPES.INDIVIDUAL) return INDIVIDUAL_KINDS[this.value?.kind]?.text || "-";
            else return "-";
        },
    },
};
</script>

<style></style>
